/**
 * WatermillMessagesListRes 类型和 Schema 定义
 *
 * ⚠️ 注意: 此文件由脚本自动生成，请勿手动修改
 * 如需更新，请运行代码生成脚本
 */
import type { SchemaDefinition } from './_schema'
import type { WatermillMessageData } from './watermill_message_data'

/**
 * WatermillMessagesListRes
 */
export interface WatermillMessagesListRes {
  items?: WatermillMessageData[]
  total?: number
  page?: number
  page_size?: number
  topic?: string
  offsets?: Record<string, number>
}

/**
 * WatermillMessagesListRes Schema
 */
export const WatermillMessagesListResSchema: SchemaDefinition = {
  properties: {
    items: {
      format: '[]*model.WatermillMessageData',
      items: { $ref: 'WatermillMessageData', description: '' },
      type: 'array',
    },
    total: {
      format: 'int',
      type: 'integer',
    },
    page: {
      format: 'int',
      type: 'integer',
    },
    page_size: {
      format: 'int',
      type: 'integer',
    },
    topic: {
      format: 'string',
      type: 'string',
    },
    offsets: {
      additionalProperties: {
        format: 'int64',
        type: 'integer',
      },
      format: 'map[string]int64',
      type: 'object',
    },
  },
  type: 'object',
}
